var exports = {
  "KE": "AdvancedSettingsTab.module__toolbar___dDhPN0",
  "uW": "AdvancedSettingsTab.module__section___dDhPN0",
  "bV": "AdvancedSettingsTab.module__sectionHeader___dDhPN0",
  "sq": "AdvancedSettingsTab.module__sectionTitleRow___dDhPN0",
  "Gf": "AdvancedSettingsTab.module__sectionTitle___dDhPN0",
  "yV": "AdvancedSettingsTab.module__sectionDescription___dDhPN0",
  "_R": "AdvancedSettingsTab.module__itemList___dDhPN0",
  "rd": "AdvancedSettingsTab.module__settingRow___dDhPN0",
  "gP": "AdvancedSettingsTab.module__settingRowFullWidth___dDhPN0",
  "cY": "AdvancedSettingsTab.module__settingMain___dDhPN0",
  "Gn": "AdvancedSettingsTab.module__settingMainInteractive___dDhPN0",
  "jF": "AdvancedSettingsTab.module__settingTitleRow___dDhPN0",
  "h3": "AdvancedSettingsTab.module__settingTitle___dDhPN0",
  "jg": "AdvancedSettingsTab.module__settingDescription___dDhPN0",
  "D9": "AdvancedSettingsTab.module__settingAction___dDhPN0",
  "kN": "AdvancedSettingsTab.module__settingActionFullWidth___dDhPN0",
  "lv": "AdvancedSettingsTab.module__controlStackCompact___dDhPN0",
  "p$": "AdvancedSettingsTab.module__emptyState___dDhPN0",
};

module.exports = exports;
